import React from 'react';
import PropTypes from "prop-types";
import { Client } from '../../client';

const placeholder = '/images/builder/placeholder.jpg';

export const RenderDetails = ({details, fabric, button, isMobile}) => {
  const { collar, cuff, fastening } = details;
  const buttonVal = ( Object.values(button).length ? Object.values(button)[0] : null)

  const addDefaultSrc = (ev) => {
      ev.target.src = placeholder
      ev.target.style.objectFit = 'contain';
  }

  const getImage = (imageGetFunction, attrValue, detailType, label) => {
      return (
          <div className={`b-rit-product-page__details-attr-detail`}>
              {<img
                  className={`b-rit-product-page__details-attr-img`}
                  src={imageGetFunction(attrValue)}
                  alt={detailType}
                  onError={addDefaultSrc}
              />}
              <span className={`b-rit-product-page__details-attr-label`}>{label}</span>
          </div>
      )
  }

  return (
      <div className='b-rit-product-page__details-attr'>
          {collar && 
              getImage(Client.getCatalogImageDetailPreview, collar.attrValue, 'collar', collar.displayName, collar)
          }
          {cuff && 
              getImage(Client.getCatalogImageDetailPreview, cuff.attrValue, 'cuff', cuff.displayName)
          }
          {fastening && 
              getImage(Client.getCatalogImageDetailPreview, fastening.attrValue, 'fastening', fastening.displayName)
          }
          {buttonVal && 
              getImage(Client.getRemarkImageUrlButton, buttonVal.attrValue, 'button', buttonVal.shortName)
          }
          {!isMobile && fabric && 
              getImage(Client.getRemarkImageUrl, fabric.article, 'fabric', fabric.displayName)
          }
      </div>
  )
}

RenderDetails.proptypes ={
    details: PropTypes.object.isRequired, 
    fabric: PropTypes.object.isRequired, 
    button: PropTypes.object.isRequired, 
    isMobile: PropTypes.bool.isRequired,
}